import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';
import { Paper, Typography } from '@mui/material';

// Register required elements for Line Chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement, // Required for Line Chart
  LineElement, // Required for Line Chart
  Tooltip,
  Legend
);

export const OrderLineChart = ({ data }) => {
  // Get unique days and statuses
  const days = [...new Set(data.map(item => item.day.trim()))];
  const statuses = [...new Set(data.map(item => item.status))];

  // Group data by day and status
  const groupedData = days.map(day => {
    const dayData = data.filter(item => item.day.trim() === day);
    return {
      day,
      ...statuses.reduce((acc, status) => {
        acc[status] = dayData
          .filter(item => item.status === status)
          .reduce((sum, curr) => sum + curr.totalAmount, 0);
        return acc;
      }, {})
    };
  });

  // Define colors for each status
  const statusColors = {
    pending: '#FFC107',
    processing: '#17A2B8',
    received: '#28A745',
    rejected: '#DC3545'
  };

  // Prepare chart data
  const chartData = {
    labels: groupedData.map(item => item.day),
    datasets: statuses.map(status => ({
      label: status.toUpperCase(),
      data: groupedData.map(item => item[status]),
      borderColor: statusColors[status],
      backgroundColor: `${statusColors[status]}33`, // Add transparency
      fill: false,
      tension: 0.4 // Smooth line
    }))
  };

  // Chart options
  const options = {
    plugins: {
      legend: { position: 'bottom' }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `$${value}`
        }
      }
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Total Amount Over Days by Status
      </Typography>
      <Line data={chartData} options={options} />
    </Paper>
  );
};